import {createSlice} from "@reduxjs/toolkit";

const messageSlice = createSlice({
    name:"message",
    initialState:{
        messages: [],
    },
    reducers:{
        setMessages:(state,action)=>{
            state.messages = action.payload;
        },
    
        addNewMessage: (state, action) => {
              // Remove any existing temp message with same content
            if (!action.payload.isTemp) {
              state.messages = state.messages.filter(msg => 
                  !(msg.isTemp && 
                    msg.senderId === action.payload.senderId && 
                    msg.message === action.payload.message &&
                    msg.createdAt <= action.payload.createdAt)
              );
          }
          
             const exists = state.messages.some(msg => msg._id === action.payload._id);
      if (!exists) {
        state.messages.push(action.payload);
      }
   
},
deleteMessage: (state, action) => {
    state.messages = state.messages.filter(msg => msg._id !== action.payload);
},


updateMessageStatus: (state, action) => {
   
    const { messageId, status, repliedBy, replied,senderId } = action.payload;
     if (state.messages) { // Additional safety check
    const messageIndex = state.messages.findIndex(msg => msg._id === messageId);
   
     if (messageIndex !== -1) {
      
         state.messages[messageIndex].status = status; // ✅ Ensure state update
         if (replied !== undefined) {
            state.messages[messageIndex].replied = replied;
        }
         if (repliedBy) {
            state.messages[messageIndex].repliedBy = repliedBy;
            // state.messages[messageIndex].replied = true;
        }
      
     }
     }
}

                   
    }
});
export const {setMessages,addNewMessage, deleteMessage,updateMessageStatus } = messageSlice.actions;
export default messageSlice.reducer;